import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaBuilding, FaSignOutAlt, FaPaperPlane, FaStar } from "react-icons/fa";
import logoImage from "../CO/images/EX-logo-1.png";

interface SidebarProps {
  onToggle?: (expanded: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem("PO")) {
      navigate("/");
    }
  }, [location, navigate]);

  const toggleSidebar = () => {
    const newExpandedState = !isExpanded;
    setIsExpanded(newExpandedState);
    onToggle?.(newExpandedState);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };

  const navItems = [
    {
      label: "Company",
      icon: <FaBuilding size={20} />,
      path: "/placement-officer/company",
    },
    {
      label: "Sent",
      icon: <FaPaperPlane size={20} />,
      path: "/placement-officer/students?view=sent",
    },
    {
      label: "Shortlist",
      icon: <FaStar size={20} />,
      path: "/placement-officer/students?view=shortlist",
    },
  ];

  return (
    <div
      className={`sidebar ${isExpanded ? "expanded" : "collapsed"}`}
      onClick={toggleSidebar}
    >
      <div className="logo-section">
        <img src={logoImage} alt="Logo" className="logo" />
      </div>

      <div className="nav-icons">
        {navItems.map((item) => {
          const [basePath, query] = item.path.split("?");
          const search = location.search || "";
          const isActive = query
            ? location.pathname === basePath && search.includes(query)
            : location.pathname === item.path && !search.includes("view=");
          return (
          <div
            key={item.path}
            className={`nav-item ${isActive ? "active" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              if (item.path.startsWith("/placement-officer/students")) {
                const target = new URL(item.path, window.location.origin);
                const next = new URLSearchParams(location.search);
                target.searchParams.forEach((value, key) => {
                  next.set(key, value);
                });
                const qs = next.toString();
                navigate(qs ? `${target.pathname}?${qs}` : target.pathname);
              } else {
                navigate(item.path);
              }
            }}
          >
            {item.icon}
            {isExpanded && <span className="nav-text">{item.label}</span>}
          </div>
          );
        })}
      </div>

      <div className="logout-container">
        <div
          className="nav-item logout-item"
          onClick={(e) => {
            e.stopPropagation();
            handleLogout();
          }}
        >
          <FaSignOutAlt size={20} />
          {isExpanded && <span className="nav-text">Logout</span>}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
